import { useDispatch, useSelector } from "react-redux";
import { updateEnvironment } from "../../../actions/environment.action";
import { replaceAttributeWithValueInObject } from "../../../utilities/Response";
import { createNewReference } from "../../../services/shared";
import LaunchIcon from '@mui/icons-material/Launch';

export const IframeLabel = (props: any) => {
  const dispatch = useDispatch();
  const attributes = useSelector((state: any) => state?.attributes);
  const { label, topMargin, iframeCTA, iframeTitle } = props;

  const openIframe = () => {
    dispatch(updateEnvironment({ iframeActive: { label, source: props.source, iframeCTA, iframeTitle, justHide: true } }));
  }

  const getTitle = () => {
    try {
      let title = replaceAttributeWithValueInObject(createNewReference(label), [...attributes]);
      title = title.replace("{{name}}", sessionStorage.getItem('name') || 'User');
      return title || label;
    } catch (error) {
      return label;
    }
  }

  return (
    <div className='max-w-80 ele-iframe'>
      <div className={`ele-iframe-title rounded-tl-xl rounded-tr-xl w-fit py-2 px-4 bg-primaryBgColor ${topMargin}`}>
        <p>{getTitle()}</p>
      </div>
      <div className="ele-iframe-open-btn-container options-container max-w-70 border-solid border-2 border-t-0 border-primaryBgColor rounded-bl-xl rounded-br-xl">
        <div className="ele-iframe-open-btn link cursor-pointer  flex justify-center p-2 items-center border-solid border-t-2 border-primaryBgColor hover:bg-secondaryBgColor" onClick={openIframe}>
          <LaunchIcon className=" text-primaryColor !text-lg mr-1 ele-iframe-launch-icon" />
          <p className="ele-iframe-cta text-primaryColor ">{iframeCTA}</p>
        </div>
      </div>
    </div>
  );
}
